import { render, staticRenderFns } from "./AttachmentPreview.vue?vue&type=template&id=315ae465"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports